import { render } from "./DeliveryTypesPanel.vue?vue&type=template&id=f5f4abce&scoped=true&ts=true"
import script from "./DeliveryTypesPanel.vue?vue&type=script&lang=ts"
export * from "./DeliveryTypesPanel.vue?vue&type=script&lang=ts"

import "./DeliveryTypesPanel.vue?vue&type=style&index=0&id=f5f4abce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f4abce"]])

export default __exports__